import { zonedTimeToUtc } from 'date-fns-tz';
import { IApiDateConverter } from '../api-date-converter';

class ApiDateConverter extends IApiDateConverter {
    public apiStringToDate(apiDateString: string): Date {
        // as long as user's timezone is not specified through the application settings - just use date constructor
        // sooner or later we will have to apply conversion to local timezone here
        return new Date(apiDateString);
    }

    public dateToAPIString(dateObject: Date, timezone?: string): string {
        const isoDate = timezone ? zonedTimeToUtc(dateObject, timezone).toISOString() : dateObject.toISOString();
        return isoDate.substr(0, 10) + 'T' + isoDate.substr(11, 8) + 'Z';
    }
}

export { ApiDateConverter };